<template>
  <div :class="['login-or', shortOrLong()]">
    <span>{{ text }}</span>
  </div>
</template>
<script>
export default {
  props: ['text', 'variant'],
  methods: {
    shortOrLong() {
      if (this.variant === 'between') return 'between';
      if (this.text === 'Или') return 'short';
      return 'long';
    },
  },
};
</script>
<style scoped>
.login-or {
  width: 100%;
  box-sizing: border-box;
  font-family: 'Manrope', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #4b5563;
  text-align: center;
}

/* “Или”: две линии по бокам надписи */
.login-or.short {
  display: flex;
  align-items: center;
  gap: 14px;
}

.login-or.short::before,
.login-or.short::after {
  content: '';
  display: block;
  flex: 1;
  height: 1px;
  background: #d5d5d6;
}

/* “Нет аккаунта?” и “Уже есть аккаунт?” */
.login-or.long {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.login-or.long::before,
.login-or.long::after {
  content: '';
  display: block;
  flex: 1;
  width: auto;
  height: 1px;
  background: #d5d5d6;
}

.login-or span {
  display: block;
  margin: 0;
  padding: 0;
}
.login-or.between {
  display: grid;
  grid-template-columns: 1fr 130px 1fr;
  grid-template-rows: 1px auto;
  column-gap: 14px;
  row-gap: 10px;
  align-items: center;
}

.login-or.between::before,
.login-or.between::after {
  content: '';
  display: block;
  height: 1px;
  background: #d5d5d6;
}

.login-or.between::before {
  grid-column: 1;
  grid-row: 1;
}

.login-or.between::after {
  grid-column: 3;
  grid-row: 1;
}

.login-or.between span {
  grid-column: 1 / -1;
  grid-row: 2;
  text-align: center;
}
</style>
